import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp12} 0;
  flex: 1;
`
